<template>
  <b-form-group
    :label="$t('fields.taskType')"
    label-for="task_type"
  >
    <b-form-input
      id="task_type"
      v-model="dataItem.task_type"
      :placeholder="$t('guides.form.taskTypePlaceholder')"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'GuidesTaskTypeCard',
  components: { BFormGroup, BFormInput },
  computed: {
    dataItem() {
      return this.$store.getters['guides/dataItem']
    },
  },
}
</script>
